import {useCallback} from 'react';
import {useMeetings} from '../../../../../../../data/hooks/meeting/useMeetings';

export function useUnblockSlotCallback(eventId) {
    const blockedMeetings = useMeetings(eventId, {filter: meeting => meeting.blocked});
    return useCallback(
        slot => {
            let meeting = blockedMeetings.find(meeting => meeting.start == slot.start && meeting.end == slot.end);
            return app.api.meetings.unblock(eventId, meeting.id);
        },
        [eventId, blockedMeetings]
    );
}
